<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom: 60px;">Dedication</h1>
<p style="text-align:center;">To Margaret and Pearl—of Blarney Nook, Venus Bay.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1e39de10